import epicContext from './context';

const {Provider: EpicContextProvider} = epicContext;

export default EpicContextProvider;
